module.exports = "<side-grid grid-title=\"Plans\" list=\"$ctrl.sections\"></side-grid>\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/plans/plans.html
// module id = 1684
// module chunks = 0